import { useState } from "react";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";
import {
  DivCharacterNav,
  DivCharacterRelateContainNav,
} from "../style/CharacterRelateContainNav.style";
import CharacterContainNavCharList from "../CharacterContainNavCharList";
import RadicalCharacterContainTypeNav from "./RadicalCharacterContainTypeNav";

type RadicalCharacterRelateContainNavProps = {
  character: CharacterResult;
};

const RadicalCharacterRelateContainNav = ({
  character,
}: RadicalCharacterRelateContainNavProps) => {
  const [navCharacter, setNavCharacter] = useState<CharacterResult | null>(
    null
  );
  const [navLetterList, setNavLetterList] = useState<CharacterLetter[]>([]);

  const navCharacterHandle = (charLetters: CharacterLetter[]) => {
    setNavLetterList(charLetters);
    // console.log("navCharacterHandle - letters.length", charLetters.length);

    if (navCharacter !== null) {
      setNavCharacter(null);
    }
  };

  return (
    <DivCharacterRelateContainNav>
      <RadicalCharacterContainTypeNav
        character={character}
        lettersGetHandle={navCharacterHandle}
      />
      {navLetterList && (
        <DivCharacterNav>
          <CharacterContainNavCharList
            navLetterList={navLetterList}
            navCharacterHandle={setNavCharacter}
            navCharacter={navCharacter}
          />
        </DivCharacterNav>
      )}
      {navCharacter !== null && (
        <RadicalCharacterRelateContainNav character={navCharacter} />
      )}
    </DivCharacterRelateContainNav>
  );
};

export default RadicalCharacterRelateContainNav;
